import { Injectable } from '@angular/core';
import { ScheduleOptionsCache } from '../../models/schedule-options-cache';
import { ReplaySubject, Observable } from 'rxjs';

@Injectable()
export class ScheduleOptionsCacheService {

  constructor() { }
  scheduleOptions: ScheduleOptionsCache = new ScheduleOptionsCache();
  _scheduleOptions: ReplaySubject<ScheduleOptionsCache> = new ReplaySubject<ScheduleOptionsCache>();

  changeOptions(showHolidays: boolean, showEvents: boolean, showExams: boolean) {
    this.scheduleOptions.showHolidays = showHolidays;
    this.scheduleOptions.showEvents = showEvents;
    this.scheduleOptions.showExams = showExams;
    this._scheduleOptions.next(this.scheduleOptions);
  }

  subscribeScheduleOptions(): Observable<ScheduleOptionsCache> {
    return this._scheduleOptions.asObservable();
  }
}
